export const GET_CURRENT_TIME_CONTEXT = {
  // 借入入力、借入実行
  BORROWING: 'borrowing',
  // 返済入力、返済実行、返済シミュレーション
  REPAYMENT: 'repayment',
  // キャンペーントップ
  CAMPAIGN_TOP: 'campaign_top',
  // キャンペーン詳細
  CAMPAIGN_DETAIL: 'campaign_detail',
  // LENSのモック設定
  MOCK: 'mock',
  // アプリケーショントップ
  APPLICATION_TOP: 'application_top',
  // サービストップ
  SERVICE_TOP: 'service_top',
} as const;

export const CONTEXTS_ENABLE_MOCK: string[] = [
  GET_CURRENT_TIME_CONTEXT.MOCK,
  GET_CURRENT_TIME_CONTEXT.BORROWING,
  GET_CURRENT_TIME_CONTEXT.REPAYMENT,
  GET_CURRENT_TIME_CONTEXT.CAMPAIGN_TOP,
  GET_CURRENT_TIME_CONTEXT.CAMPAIGN_DETAIL,
  GET_CURRENT_TIME_CONTEXT.APPLICATION_TOP,
  GET_CURRENT_TIME_CONTEXT.SERVICE_TOP,
];
